import React, { createContext, useContext, useState, useCallback } from "react";

const TopToolbarContext = createContext(null);

export const TopToolbarProvider = ({ children }) => {
  const [content, setContent] = useState({ left: null, right: null });

  // Accept either a node (legacy -> right) or an object { left, right }
  const setToolbar = useCallback((payload) => {
    if (payload && typeof payload === 'object' && (payload.left !== undefined || payload.right !== undefined)) {
      setContent((prev) => ({ ...prev, ...payload }));
    } else {
      setContent((prev) => ({ ...prev, right: payload }));
    }
  }, []);

  const clearToolbar = useCallback(() => setContent({ left: null, right: null }), []);

  return (
    <TopToolbarContext.Provider value={{ content, setToolbar, clearToolbar }}>
      {children}
    </TopToolbarContext.Provider>
  );
};

export const useTopToolbar = () => {
  const ctx = useContext(TopToolbarContext);
  if (!ctx) throw new Error("useTopToolbar must be used within TopToolbarProvider");
  return ctx;
};

export default TopToolbarContext;
